import {
  ROUTES_LOADED,
  CHANGE_SELECTED_FILTERS,
  SHOW_ROUTE_DETAILS,
  UPDATE_LIST_ROUTE,
  ROUTES_DEPOT_STATS_LOADED,
} from "../actions/routes";

const initialState = {
  routes: {},
  selectedFilters: [],
  routeDetailId: null,
  depotStats: {},
};

const routesData = (state = initialState, action) => {
  switch (action.type) {
    case ROUTES_LOADED:
      return {
        ...state,
        routes: action.payload,
      };
    case ROUTES_DEPOT_STATS_LOADED:
      return {
        ...state,
        depotStats: action.payload,
      };
    case CHANGE_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: action.payload,
      };

    case SHOW_ROUTE_DETAILS:
      return {
        ...state,
        routeDetailId: action.payload,
      };
    case UPDATE_LIST_ROUTE:
      return {
        ...state,
        routes: {
          ...state.routes,
          [action.payload.routeId]: action.payload,
        },
      };
    default:
      return state;
  }
};

export default routesData;
